/**
 * Central configuration for AI agents and models
 * Used by: ProjectSettings, AnalyzeModal, ImplementModal
 */

// AI Agent providers
export const AI_AGENTS = {
  CURSOR: 'cursor',
  CLAUDE: 'claude',
  CODEX:  'codex',
  GEMINI: 'gemini',
};

// Cursor Agent models (from `agent models` CLI output)
export const CURSOR_MODELS = [
  { id: 'auto', name: 'Auto (Recommended)' },
  { id: 'opus-4.5-thinking', name: 'Claude 4.5 Opus (Thinking)' },
  { id: 'opus-4.5', name: 'Claude 4.5 Opus' },
  { id: 'sonnet-4.5', name: 'Claude 4.5 Sonnet' },
  { id: 'sonnet-4.5-thinking', name: 'Claude 4.5 Sonnet (Thinking)' },
  { id: 'composer-1', name: 'Composer 1' },
  { id: 'gpt-5.2-codex', name: 'GPT-5.2 Codex' },
  { id: 'gpt-5.2-codex-high', name: 'GPT-5.2 Codex High' },
  { id: 'gpt-5.2-codex-fast', name: 'GPT-5.2 Codex Fast' },
  { id: 'gpt-5.2', name: 'GPT-5.2' },
  { id: 'gpt-5.2-high', name: 'GPT-5.2 High' },
  { id: 'gemini-3-pro', name: 'Gemini 3 Pro' },
  { id: 'gemini-3-flash', name: 'Gemini 3 Flash' }
];

// Claude API models (from Anthropic docs)
export const CLAUDE_MODELS = [
  { id: 'claude-sonnet-4-5-20250929', name: 'Claude Sonnet 4.5 (Recommended)' },
  { id: 'claude-opus-4-5-20251101', name: 'Claude Opus 4.5' },
  { id: 'claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5' }
];

// Codex CLI / OpenAI models. Aliases MUST match
// packages/core/src/constants.js CODEX_MODEL_MAP — keep in lockstep.
// Adding a new model here without adding it to that map will let the
// user pick a value the CLI doesn't recognize.
export const CODEX_MODELS = [
  { id: 'auto',           name: 'Auto (o4-mini)' },
  { id: 'gpt-5.4',        name: 'GPT-5.4' },
  { id: 'gpt-5.3',        name: 'GPT-5.3' },
  { id: 'gpt-5.2-codex',  name: 'GPT-5.2 Codex' },
  { id: 'gpt-5.2',        name: 'GPT-5.2' },
  { id: 'o4-mini',        name: 'o4-mini' },
  { id: 'o3',             name: 'o3' },
  { id: 'o3-mini',        name: 'o3-mini' },
  { id: 'codex-mini',     name: 'codex-mini' },
  { id: 'gpt-4o',         name: 'GPT-4o' },
  { id: 'gpt-4o-mini',    name: 'GPT-4o mini' },
];

// Gemini CLI / Google Gemini models.
export const GEMINI_MODELS = [
  { id: 'gemini-2.5-pro',   name: 'Gemini 2.5 Pro (Recommended)' },
  { id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash' },
];

// Get models for a specific agent
export const getModelsForAgent = (agent) => {
  if (agent === AI_AGENTS.CLAUDE) return CLAUDE_MODELS;
  if (agent === AI_AGENTS.CODEX)  return CODEX_MODELS;
  if (agent === AI_AGENTS.GEMINI) return GEMINI_MODELS;
  return CURSOR_MODELS;
};

// Get default model for an agent
export const getDefaultModelForAgent = (agent) => {
  if (agent === AI_AGENTS.CLAUDE) return 'claude-sonnet-4-5-20250929';
  if (agent === AI_AGENTS.GEMINI) return 'gemini-2.5-pro';
  return 'auto';
};
